/* VitaFresh Kopf- und Fusszeile (Pasci 09.10.2026). Markup: sections/header.liquid, footer.liquid, snippets/vf-plz.liquid.
   1. Zeile 2 bekommt «klebt» (Mini-Logo, Suche, Warenkorb), sobald Zeile 1 aus dem Bild ist. Kleben selbst macht CSS.
   2. Mega-Menü und Dropdown: Hover erst, wenn die Maus kurz ruht, Klick, Enter/Leertaste (native Knöpfe), Esc (auch
      bei Hover, WCAG 1.4.13), Klick daneben.
   3. Handy: Tab «Gerichte» öffnet das Menü-Sheet mit «Gerichte» aufgeklappt, Tab «Suche» mit Fokus im Suchfeld.
      Fokus geht beim Öffnen ins Sheet und beim Schliessen zurück; öffnet der Warenkorb, schliesst das Sheet (nur eine
      Seitenleiste offen).
   4. PLZ-Abfrage: Antwort im Browser aus den Liefergebieten der Metaobjekte (JSON #vf-liefer-daten, snippets/vf-liefer-daten.liquid)
      mit VFLiefer.plzGebiet (assets/vf-liefertermin-logik.js, dieselbe Quelle wie der Kalender im Warenkorb, Pasci 15.10.2026).
      Das Logik-Skript wird erst beim ersten Fokus oder Absenden geladen (bei gemerkter PLZ nach dem Seitenaufbau, im Leerlauf).
      Die PLZ geht an nichts Externes (Feld ohne name, Formular ohne Ziel), nur in localStorage. Fehlen Daten: keine Antwort erfinden.
   5. Handy: Chip «Liefergebiet?» in der Chip-Reihe (Pasci 21.10.2026) öffnet das Menü-Sheet mit derselben PLZ-Abfrage (kein zweites
      Prüfen) und zeigt mit PLZ im Gebiet «✓ 8000». Ohne Skript führt der Link zum PLZ-Feld im Fuss.
   Ohne dieses Skript bleibt alles bedienbar (Links, Formulare, Theme-Drawer). */
(function (root) {
  'use strict';

  var OEFFNEN_MS = 220; /* Hover: so lange muss die Maus ruhen, bevor das Menü aufgeht (kein Flackern beim Überfahren) */
  var RUHE_MAX_MS = 600; /* länger auf dem Punkt bewegt = Absicht: öffnet auch ohne Ruhe */
  var SCHLIESSEN_MS = 220; /* Hover weg: so lange bleibt es offen (Weg zum Panel) */
  var HOVER_KLICK_MS = 500; /* Klick kurz nach Hover-Öffnen schliesst nicht gleich wieder */
  var SPEICHER = 'vfk-plz';

  /* ---------- Reine Logik (in Node getestet: tests/vf-kopffuss.test.js) ---------- */
  /* 'ungueltig' | 'offen' (keine Daten oder Logik: keine Antwort) | 'treffer' | 'kein'; Schweizer PLZ 1000–9999.
     daten: JSON aus #vf-liefer-daten, logik: window.VFLiefer (nur aktive Gebiete zählen). Liefertage werden nie angezeigt. */
  function plzPruefen(plz, daten, logik) {
    plz = String(plz == null ? '' : plz).trim();
    if (!/^[1-9]\d{3}$/.test(plz)) return 'ungueltig';
    if (!logik || !daten || !Array.isArray(daten.gebiete) || !daten.gebiete.length) return 'offen';
    return logik.plzGebiet(daten, plz) ? 'treffer' : 'kein';
  }
  /* Name des Warenkorb-Knopfs für Screenreader: «Warenkorb öffnen: CHF 48.50, 2 Artikel» */
  function korbName(basis, summe, anzahl) {
    var n = parseInt(anzahl, 10);
    summe = String(summe == null ? '' : summe).replace(/\s+/g, ' ').trim();
    return String(basis || '').trim() + ': ' + (summe ? summe + ', ' : '') + (n > 0 ? n : 0) + ' Artikel';
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { plzPruefen: plzPruefen, korbName: korbName };
    return;
  }

  var doc = root.document;
  doc.documentElement.classList.add('vfk-js');

  function lesen() { try { return root.localStorage.getItem(SPEICHER); } catch (e) { return null; } }
  function schreiben(wert) {
    try { if (wert) root.localStorage.setItem(SPEICHER, wert); else root.localStorage.removeItem(SPEICHER); } catch (e) { /* privat: nur ohne Merken */ }
  }

  /* ---------- 1. Klebende Zeile 2 ---------- */
  function klebenEinrichten(kopf) {
    var z1 = kopf.querySelector('.vfk-z1');
    var z2 = kopf.querySelector('[data-vfk-z2]');
    if (!z1 || !z2 || !('IntersectionObserver' in root)) return;
    /* Ohne Layout-Shift: «Dein Ziel» bleibt im Fluss (nur unsichtbar), das Hauptmenü rückt per transform in die Mitte.
       --vfk-schub = halbe Breite von Trenner und «Dein Ziel» (0, wenn sie ausgeblendet sind, 1024–1279 px). */
    var mitte = z2.querySelector('.vfk-z2__mitte');
    var nav = mitte && mitte.querySelector('.vfk-nav');
    /* Beim Kleben ist das verschobene Menü der Bezugsrahmen des Mega-Menüs (transform): --vfk-mega-l und --vfk-mega-b geben ihm
       die ganze Zeile zurück (vf-kopf-menue.css). offsetLeft misst ohne transform, darum + Schub. */
    function schub() {
      if (!nav) return;
      var px = Math.round((mitte.offsetWidth - nav.offsetWidth) / 2);
      z2.style.setProperty('--vfk-schub', px + 'px');
      z2.style.setProperty('--vfk-mega-l', (mitte.offsetLeft + px) + 'px');
      z2.style.setProperty('--vfk-mega-b', z2.clientWidth + 'px');
    }
    root.addEventListener('resize', schub, { passive: true });
    /* rootMargin -1px: Zeile 1 bleibt in der klebenden Section bündig über dem Rand stehen, das zählt sonst als «sichtbar» */
    new root.IntersectionObserver(function (eintraege) {
      var e = eintraege[eintraege.length - 1];
      schub();
      z2.classList.toggle('klebt', !e.isIntersecting && e.boundingClientRect.top < 0);
    }, { rootMargin: '-1px 0px 0px 0px' }).observe(z1);
  }

  /* ---------- 2. Mega-Menü und Dropdown ---------- */
  var hover = root.matchMedia ? root.matchMedia('(hover: hover)') : { matches: false };
  function knopf(p) { return p.querySelector('[aria-controls]'); }
  /* Mega-Menü: Höhe am echten Abstand zum oberen Fensterrand, damit es bei kleiner Fensterhöhe intern scrollt statt unten abzuschneiden */
  function megaHoehe() {
    var mega = doc.querySelector('[data-vfk-punkt][data-offen] > .vfk-mega');
    if (mega) mega.style.setProperty('--vfk-mega-top', Math.max(0, Math.round(mega.getBoundingClientRect().top)) + 'px');
  }
  var megaRahmen = 0;
  function megaHoeheBald() {
    if (megaRahmen) return;
    megaRahmen = root.requestAnimationFrame(function () { megaRahmen = 0; megaHoehe(); });
  }
  root.addEventListener('scroll', megaHoeheBald, { passive: true });
  root.addEventListener('resize', megaHoeheBald, { passive: true });
  function setzen(p, offen) {
    clearTimeout(p.vfkTimer);
    if (offen) p.setAttribute('data-offen', ''); else p.removeAttribute('data-offen');
    knopf(p).setAttribute('aria-expanded', offen ? 'true' : 'false');
    if (offen) megaHoehe();
  }
  function alleZu(ausser) {
    Array.prototype.forEach.call(doc.querySelectorAll('[data-vfk-punkt][data-offen]'), function (p) { if (p !== ausser) setzen(p, false); });
  }
  /* Klick daneben schliesst (ein Listener für die ganze Seite) */
  doc.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('[data-vfk-punkt]')) alleZu(null);
  });
  /* Esc auf Dokument-Ebene: schliesst auch ein per Hover geöffnetes Menü (Maus bleibt stehen) und die Sprach-/Länderliste
     im Fuss (Theme-Snippet localization-form). Fokus zurück auf den Knopf nur, wenn er drin war. */
  doc.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    Array.prototype.forEach.call(doc.querySelectorAll('[data-vfk-punkt][data-offen]'), function (p) {
      var drin = p.contains(doc.activeElement);
      setzen(p, false);
      p.vfkWartet = false;
      if (drin) knopf(p).focus();
    });
    Array.prototype.forEach.call(doc.querySelectorAll('.vfk-fuss [data-js-localization-form-content].content-opened'), function (liste) {
      var form = liste.parentNode;
      var k = form.querySelector('[data-js-localization-form-button]');
      var drin = form.contains(doc.activeElement);
      liste.classList.remove('content-opened', 'invert-x', 'invert-y');
      form.style.zIndex = 9;
      if (k) { k.setAttribute('aria-expanded', 'false'); if (drin) k.focus(); }
    });
  });

  function menueEinrichten(kopf) {
    var punkte = Array.prototype.slice.call(kopf.querySelectorAll('[data-vfk-punkt]'));

    punkte.forEach(function (p) {
      var k = knopf(p);
      if (!k) return;
      k.addEventListener('click', function () {
        var offen = p.hasAttribute('data-offen');
        if (offen && Date.now() - (p.vfkHoverSeit || 0) < HOVER_KLICK_MS) return;
        alleZu(p);
        setzen(p, !offen);
        p.vfkHoverSeit = 0;
      });
      function aufHover() { p.vfkWartet = false; alleZu(p); setzen(p, true); p.vfkHoverSeit = Date.now(); }
      function warten() { clearTimeout(p.vfkTimer); p.vfkTimer = setTimeout(aufHover, OEFFNEN_MS); }
      p.addEventListener('mouseenter', function () {
        if (!hover.matches) return;
        clearTimeout(p.vfkTimer);
        if (p.hasAttribute('data-offen')) return;
        /* Ein anderes Panel ist schon offen: Wechsel sofort */
        if (doc.querySelector('[data-vfk-punkt][data-offen]')) { aufHover(); return; }
        p.vfkWartet = true;
        p.vfkSeit = Date.now();
        warten();
      });
      /* Bewegt sich die Maus noch, ist es (noch) keine Absicht: Zeit neu starten, höchstens bis RUHE_MAX_MS */
      p.addEventListener('mousemove', function () {
        if (p.vfkWartet && Date.now() - p.vfkSeit < RUHE_MAX_MS) warten();
      });
      p.addEventListener('mouseleave', function () {
        if (!hover.matches) return;
        p.vfkWartet = false;
        clearTimeout(p.vfkTimer);
        if (p.hasAttribute('data-offen')) p.vfkTimer = setTimeout(function () { setzen(p, false); }, SCHLIESSEN_MS);
      });
      p.addEventListener('focusout', function (e) {
        if (e.relatedTarget && !p.contains(e.relatedTarget)) setzen(p, false);
      });
    });
  }

  /* ---------- 3. Handy: Tabs der unteren Leiste und Sheet ---------- */
  /* Theme (section-header.js) setzt aria-expanded nur am ersten Knopf zurück: alle Knöpfe mit dem Zustand der Seitenleiste
     abgleichen (Menü-Sheet und Overlay-Warenkorb). Zu: alle false; offen: Tabs der Leiste true, die übrigen setzt das Theme. */
  /* Beim Schliessen geht der Fokus zurück auf den Knopf, der geöffnet hat (wenn er auf body oder in der Leiste stand und
     keine andere Seitenleiste aufgeht). */
  function seitenleisteAbgleichen(sektion, id) {
    var leiste = doc.getElementById(id);
    if (!leiste || !('MutationObserver' in root)) return;
    var steuer = sektion.querySelectorAll('[aria-controls="' + id + '"]');
    var ausloeser = null;
    var war = leiste.classList.contains('sidebar--opened');
    doc.addEventListener('click', function (e) {
      /* Tab «Suche» öffnet das Sheet ohne aria-controls (ist ein Link zur Suchseite) */
      var el = e.target.closest && e.target.closest('[aria-controls="' + id + '"]' + (id === 'site-menu-sidebar' ? ',[data-vfk-tab]' : ''));
      if (el) ausloeser = el;
    }, true);
    new root.MutationObserver(function () {
      var o = leiste.classList.contains('sidebar--opened');
      Array.prototype.forEach.call(steuer, function (el) {
        if (el.hasAttribute('data-vfk-tab') || !o) el.setAttribute('aria-expanded', o ? 'true' : 'false');
      });
      if (war && !o) {
        /* Theme-Overlay der Suche (im Sheet) nie aktiv zurücklassen */
        Array.prototype.forEach.call(leiste.querySelectorAll('.search-results-overlay.active'), function (ov) { ov.classList.remove('active'); });
        var k = ausloeser;
        setTimeout(function () {
          var a = doc.activeElement;
          if (!k || doc.body.classList.contains('sidebar-opened') || (a && a !== doc.body && !leiste.contains(a))) return;
          if (a && a.blur) a.blur(); /* Feld im Sheet los: sonst bleibt die Leiste beim Tippen ausgeblendet (vf-kopffuss.css) */
          if (k.getClientRects().length) k.focus({ preventScroll: true });
        }, 40);
      }
      war = o;
    }).observe(leiste, { attributes: true, attributeFilter: ['class'] });
  }
  function sheetEinrichten(sektion) {
    var sheet = doc.getElementById('site-menu-sidebar');
    if (!sheet) return;
    function offen() { return sheet.classList.contains('sidebar--opened') || sheet.opened === true; }
    seitenleisteAbgleichen(sektion, 'site-menu-sidebar');
    var zu = sheet.querySelector('[data-js-close]');
    /* Öffnen per Tipp/Klick (Burger, Tab): Fokus ins Sheet auf «Schliessen» (Enter macht das Theme selbst) */
    Array.prototype.forEach.call(doc.querySelectorAll('[aria-controls="site-menu-sidebar"]:not([data-vfk-tab])'), function (k) {
      k.addEventListener('click', function () {
        setTimeout(function () { if (offen() && zu && !sheet.contains(doc.activeElement)) zu.focus({ preventScroll: true }); }, 0);
      });
    });
    /* Nur eine Seitenleiste: öffnet der Warenkorb, schliesst das Sheet zuerst (Capture: vor dem Theme-Handler) */
    doc.addEventListener('click', function (e) {
      if (offen() && e.target.closest && e.target.closest('[aria-controls="site-cart-sidebar"]')) sheet.hide();
    }, true);
    /* Drehen/Vergrössern auf Desktop-Breite: Sheet zu (es gehört zum Handy-Kopf) */
    if (root.matchMedia) {
      var desk = root.matchMedia('(min-width: 1024px)');
      var wechsel = function () { if (desk.matches && offen()) sheet.hide(); };
      if (desk.addEventListener) desk.addEventListener('change', wechsel); else if (desk.addListener) desk.addListener(wechsel);
    }

    function oeffnen(was) {
      if (typeof sheet.show !== 'function') return false;
      var gerichte = sheet.querySelector('[data-vfk-gerichte]');
      if (!offen()) sheet.show();
      if (was === 'gerichte' && gerichte) {
        gerichte.open = true;
        setTimeout(function () { gerichte.scrollIntoView({ block: 'start' }); }, 30);
      }
      if (was === 'suche') {
        /* synchron im Tipp-Ereignis, sonst öffnet iOS keine Tastatur (das Sheet ist nach show() schon sichtbar) */
        var feld = sheet.querySelector('[data-vfk-sheet-suche]');
        if (feld) feld.focus({ preventScroll: true });
      } else if (zu) {
        zu.focus({ preventScroll: true });
      }
      return true;
    }
    Array.prototype.forEach.call(sektion.querySelectorAll('[data-vfk-tab]'), function (tab) {
      tab.addEventListener('click', function (e) {
        var was = tab.getAttribute('data-vfk-tab');
        if (was === 'gerichte' && offen()) { sheet.hide(); return; }
        if (oeffnen(was)) e.preventDefault();
      });
    });
  }

  /* ---------- Warenkorb-Knöpfe: Name mit Betrag und Anzahl (Screenreader), folgt dem Theme (refreshCart) ----------
     Die Anzahl ist die des Kopfzählers, also ohne Kühltasche (snippets/vf-korb-anzahl.liquid, Pasci 21.10.2026). */
  function korbEinrichten(sektion) {
    var knoepfe = sektion.querySelectorAll('[data-vfk-korb]');
    var summe = sektion.querySelector('[data-header-cart-total]');
    var anzahl = sektion.querySelector('[data-header-cart-count]');
    if (!knoepfe.length || !anzahl) return;
    function setzenName() {
      Array.prototype.forEach.call(knoepfe, function (k) {
        k.setAttribute('aria-label', korbName(k.getAttribute('data-vfk-korb'), summe ? summe.textContent : '', anzahl.textContent));
      });
    }
    setzenName();
    [summe, anzahl].forEach(function (el) {
      if (el) new root.MutationObserver(setzenName).observe(el, { childList: true, characterData: true, subtree: true });
    });
  }

  /* ---------- Zähler der Leiste: «0» nicht zeigen ---------- */
  function zaehlerEinrichten(sektion) {
    Array.prototype.forEach.call(sektion.querySelectorAll('[data-vfk-zahl]'), function (z) {
      function pruefen() {
        var n = parseInt(z.textContent, 10);
        if (n > 0) z.removeAttribute('data-null'); else z.setAttribute('data-null', '');
      }
      pruefen();
      new root.MutationObserver(pruefen).observe(z, { childList: true, characterData: true, subtree: true });
    });
  }

  /* ---------- 4. PLZ-Abfrage ---------- */
  /* Daten stehen im Seitenaufbau (#vf-liefer-daten), das Logik-Skript (data-vfk-plz-quelle, snippets/vf-plz.liquid) kommt erst bei
     Bedarf; auf der Warenkorbseite ist es schon da. Einmal geladen, für alle Felder. Fehler (offline, 404, kaputtes JSON): keine
     Antwort, beim nächsten Versuch neu laden. */
  var plzDaten = null;
  var plzLaden = null;
  /* DOMContentLoaded, als Rückfall load (falls dieses Skript einmal erst nach DOMContentLoaded läuft, Prüfung A7) */
  var domFertig = doc.readyState === 'complete';
  var domWarten = [];
  function domBereit() { if (domFertig) return; domFertig = true; domWarten.splice(0).forEach(function (f) { f(); }); }
  if (!domFertig) { doc.addEventListener('DOMContentLoaded', domBereit, { once: true }); root.addEventListener('load', domBereit, { once: true }); }
  function datenLesen() {
    if (plzDaten) return plzDaten;
    var s = doc.getElementById('vf-liefer-daten');
    try { plzDaten = s ? JSON.parse(s.textContent) : null; } catch (e) { plzDaten = null; }
    return plzDaten;
  }
  function logikHolen() {
    if (root.VFLiefer) return Promise.resolve(root.VFLiefer);
    if (plzLaden) return plzLaden;
    var el = doc.querySelector('[data-vfk-plz-quelle]');
    var url = el && el.getAttribute('data-vfk-plz-quelle');
    if (!url) return Promise.resolve(null);
    plzLaden = new Promise(function (fertig) {
      function laden() {
        var s = doc.createElement('script');
        s.addEventListener('load', function () { fertig(root.VFLiefer || null); });
        s.addEventListener('error', function () { if (s.parentNode) s.parentNode.removeChild(s); fertig(null); });
        s.src = url;
        doc.head.appendChild(s);
      }
      /* Auf der Warenkorbseite steht das Skript schon (defer): Defer-Skripte laufen vor DOMContentLoaded. Danach steht
         VFLiefer, oder das Skript ist gescheitert, dann kommt kein error mehr (Code-Prüfung A7): frisch laden statt ewig warten. */
      if (!doc.querySelector('script[src="' + url + '"]')) return laden();
      function danach() { if (root.VFLiefer) fertig(root.VFLiefer); else laden(); }
      if (domFertig) danach(); else domWarten.push(danach);
    }).then(function (l) { plzLaden = null; return l; });
    return plzLaden;
  }
  function pruefen(plz) {
    return logikHolen().then(function (l) { return plzPruefen(plz, datenLesen(), l); });
  }
  function plzZeigen(zustand, plz) {
    Array.prototype.forEach.call(doc.querySelectorAll('[data-vfk-plz]'), function (el) {
      el.setAttribute('data-zustand', zustand);
      Array.prototype.forEach.call(el.querySelectorAll('[data-vfk-plz-wert]'), function (w) { w.textContent = plz || ''; });
    });
    chipZeigen(zustand, plz);
  }
  /* Chip: «✓ 8000» nur mit PLZ im Gebiet, sonst «Liefergebiet?». Die Breite schrumpft nie (min-width beim ersten Wechsel), damit die
     Chips dahinter nicht springen (CLS), wenn die gemerkte PLZ erst nach dem Seitenaufbau bestätigt wird. */
  function chipZeigen(zustand, plz) {
    Array.prototype.forEach.call(doc.querySelectorAll('[data-vfk-plz-chip]'), function (c) {
      var t = c.querySelector('[data-vfk-plz-chip-text]');
      var treffer = zustand === 'treffer' && plz;
      if (!c.style.minWidth && c.offsetWidth) c.style.minWidth = c.offsetWidth + 'px';
      c.setAttribute('data-zustand', treffer ? 'treffer' : zustand);
      if (t) t.textContent = treffer ? '\u2713 ' + plz : c.getAttribute('data-text') || '';
      if (treffer) c.setAttribute('aria-label', (c.getAttribute('data-treffer') || '') + ' ' + plz); else c.removeAttribute('aria-label');
    });
  }
  /* Tipp auf den Chip: Menü-Sheet auf, Fokus synchron ins PLZ-Feld (sonst öffnet iOS keine Tastatur) bzw. auf «ändern», wenn schon eine
     Antwort steht. Fehlt das Sheet (oder sein show), bleibt der Link zum Fuss. */
  function chipEinrichten(sektion) {
    Array.prototype.forEach.call(sektion.querySelectorAll('[data-vfk-plz-chip]'), function (c) {
      c.addEventListener('click', function (e) {
        var sheet = doc.getElementById('site-menu-sidebar');
        var box = sheet && sheet.querySelector('[data-vfk-plz]');
        if (!box || typeof sheet.show !== 'function') return;
        e.preventDefault();
        if (sheet.opened !== true && !sheet.classList.contains('sidebar--opened')) sheet.show();
        c.setAttribute('aria-expanded', 'true');
        var z = box.getAttribute('data-zustand');
        var ziel = z === 'treffer' || z === 'kein' ? box.querySelector('.vfk-plz__zeile--' + z + ' [data-vfk-plz-aendern]') : box.querySelector('input');
        if (ziel) ziel.focus({ preventScroll: true });
        logikHolen();
        setTimeout(function () { box.scrollIntoView({ block: 'center' }); }, 30);
      });
    });
  }
  function plzEinrichten(el) {
    var form = el.querySelector('form');
    var feld = el.querySelector('input');
    if (!form || !feld) return;
    feld.addEventListener('focus', function () { logikHolen(); });
    form.addEventListener('submit', function (e) {
      e.preventDefault(); /* nie wegschicken; ungültige Eingaben hält schon der Browser auf (required, pattern) */
      var plz = feld.value.trim();
      if (plzPruefen(plz) === 'ungueltig') return;
      pruefen(plz).then(function (ergebnis) {
        if (ergebnis !== 'treffer' && ergebnis !== 'kein') return; /* Daten fehlen: nichts erfinden */
        schreiben(plz);
        plzZeigen(ergebnis, plz);
      });
    });
    Array.prototype.forEach.call(el.querySelectorAll('[data-vfk-plz-aendern]'), function (k) {
      k.addEventListener('click', function () {
        schreiben(null);
        plzZeigen('leer', '');
        feld.value = '';
        feld.focus();
      });
    });
  }
  /* Gemerkte PLZ: Logik erst nach dem Seitenaufbau im Leerlauf holen (Browser-Cache), dann Antwort zeigen */
  function plzStart() {
    var gemerkt = lesen();
    if (plzPruefen(gemerkt) === 'ungueltig') return;
    function holen() {
      pruefen(gemerkt).then(function (ergebnis) {
        if ((ergebnis === 'treffer' || ergebnis === 'kein') && lesen() === gemerkt) plzZeigen(ergebnis, gemerkt);
      });
    }
    function spaeter() { if (root.requestIdleCallback) root.requestIdleCallback(holen, { timeout: 3000 }); else root.setTimeout(holen, 1); }
    if (root.VFLiefer || doc.readyState === 'complete') spaeter(); else root.addEventListener('load', spaeter, { once: true });
  }

  /* ---------- Start (einmal je Element; Theme-Editor lädt Sections neu) ---------- */
  function einrichten() {
    Array.prototype.forEach.call(doc.querySelectorAll('[data-vfk-kopf]:not([data-vfk-bereit])'), function (kopf) {
      kopf.setAttribute('data-vfk-bereit', '');
      var sektion = kopf.parentNode;
      klebenEinrichten(kopf);
      menueEinrichten(kopf);
      sheetEinrichten(sektion);
      seitenleisteAbgleichen(sektion, 'site-cart-sidebar');
      zaehlerEinrichten(sektion);
      korbEinrichten(sektion);
      chipEinrichten(kopf);
    });
    Array.prototype.forEach.call(doc.querySelectorAll('[data-vfk-plz]:not([data-vfk-bereit])'), function (el) {
      el.setAttribute('data-vfk-bereit', '');
      plzEinrichten(el);
    });
    plzStart();
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', einrichten); else einrichten();
  /* Kalender im Warenkorb (assets/vf-liefertermin.js) hat eine neue PLZ gespeichert: Speicher neu lesen und sofort zeigen (eine PLZ) */
  doc.addEventListener('vf:plz', function () {
    var p = lesen();
    if (plzPruefen(p) === 'ungueltig') return;
    pruefen(p).then(function (ergebnis) { if ((ergebnis === 'treffer' || ergebnis === 'kein') && lesen() === p) plzZeigen(ergebnis, p); });
  });
  doc.addEventListener('shopify:section:load', einrichten);
})(typeof window !== 'undefined' ? window : globalThis);
